import { Route, RouteConfig } from "vue-router";
import config from "@/config";
import { enrichRouteMeta } from "@/router/helpers";
import { profileRoutes } from "@/router/routes/profile";

const routes: RouteConfig[] = [
  ...(config.featureLoginAsUser
    ? [
        {
          path: "/login/token/:token",
          name: "loginToken",
          component: () => import("@/views/PageLoginToken"),
          props: true,
        },
      ]
    : []),
  {
    path: "/logout",
    name: "logout",
  },
  ...(!config.featurePrivateProfile ? profileRoutes : []),
  {
    path: "/discover/:type",
    name: "discover",
    components: {
      default: () => import("@/views/PagePromotedUsers"),
      unlockFeed: () => import(/* webpackChunkName: "profile" */ "@/views/UnlockFeed"),
      stories: () => import("@/views/Stories"),
    },
    props: {
      default: (route: Route) => ({
        promotedType: route.params.type,
      }),
    },
  },
  {
    path: "/complaints",
    name: "complaints",
    components: {
      default: () => import("@/views/PageComplaints"),
    },
  },
];

export default routes.map(route => enrichRouteMeta(route, {}));
